import React, { useEffect, useRef, useState } from "react";
import { Divider, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchFiles } from "../../../../features/fetch/fetchSlice";
import svg8 from "../../../../assets/svg/svg8.svg";
import svg9 from "../../../../assets/svg/svg9.svg";
import { formatPathDoc } from "../../../../utils";
 
const VerficationDocsModal = ({ isModalOpen, handleCancel, prodd }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const downloadFile = async (item) => {
      try {
        const res = await dispatch(fetchFiles({ file: item?.pfFilePath }));
        if (res?.payload) {
          window.open(res.payload, "_blank");
        }
      } catch (error) {
        console.error("Failed to open file:", error);
      }
    };
    const data = []
  return (
    <Modal
      title={`Review Information`}
      open={isModalOpen} 
      onCancel={handleCancel}
      className="!w-[29.5rem]" 
    >
             <div className="mt-[2rem]">
          {data &&
            data?.map((item) => (
              <>
                <div className="cursor-pointer flex items-center justify-between">
                  <div className="flex items-center gap-x-[.5rem]">
                    <img src={svg8} alt="svg8" />
                    <span
                      onClick={() => downloadFile(item)}
                      className="text-[#706F6F] font-interSans font-[400] text-[.95rem]"
                    >
                      <span
                        onClick={() => downloadFile(item)}
                        title={formatPathDoc(item?.pfFileName)}
                        className="text-[#706F6F] font-interSans font-[400] text-[.95rem] cursor-pointer"
                      >
                        {formatPathDoc(item?.pfFileName)?.length > 10
                          ? formatPathDoc(item?.pfFileName).slice(0, 10) + "..."
                          : formatPathDoc(item?.pfFileName)}
                      </span>
                    </span>
                  </div>

                  <div
                    onClick={() => downloadFile(item)}
                    className="flex items-center gap-x-[.5rem]"
                  >
                    <img src={svg9} alt="svg9" />
                  </div>
                </div>
                <div className="my-[1.38rem] ">
                  <Divider />
                </div>
              </>
            ))}
        </div>
      <div className="flex justify-end ">
        <button
          type="button"
          key="back"
          onClick={handleCancel}
          className="cstm-btn !w-[100px]"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};
export default VerficationDocsModal;
